import { ArrowLeft } from 'lucide-react';
import { Link } from '../../plugs/link';

export function SnapshotBackLink({ offerId, label }: { offerId: string; label: string }) {
  return (
    <Link
      to={`/offers/${offerId}?tab=versions`}
      className="inline-flex items-center gap-2 text-sm font-medium text-primary hover:underline"
    >
      <ArrowLeft className="h-4 w-4" />
      {label}
    </Link>
  );
}
